var cookies = require('cookies/cookie');

$('.selection-toggle').on('click',function(e){
  var propertyId = $(this).data('property');
  var selection = cookies.get('megagence-selection');
  var element = this;
  var svg = $("svg",element);
  var filePath = svg.data('file');
  if(selection === null) {
    selection = [];
  }
  else {
    selection = JSON.parse(selection);
  }



  if($(this).hasClass('selection-add')) {
    selection.push(propertyId);
    selection = _.uniq(selection);
    $(this).addClass('selection-remove')
      .removeClass('selection-add')
      .attr('title',"Retirer de ma selection");
     $('use',svg).attr('xlink:href', filePath+'#etoile_x5F_pleine');
  }else{
    selection = _.without(selection, propertyId);
    $(this).removeClass('selection-remove')
      .addClass('selection-add')
      .attr('title',"Ajouter à ma selection");
     $('use',svg).attr('xlink:href', filePath+'#etoile_x5F_filaire');

  }


  if($(this).hasClass('selection-delete')){
    selection = _.without(selection, propertyId);
    $(this).closest('.list-prop-li').fadeOut();
  }


  cookies.set('megagence-selection',JSON.stringify(selection),31);

  return false;
});
